var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "main-body-wrapper" },
    [
      _c(
        "div",
        { staticClass: "header-wrapper" },
        [
          !_vm.isMobile ? _c("Header") : _vm._e(),
          _vm.isMobile && !_vm.isMobileLandscapeCal
            ? _c("Notifications")
            : _vm._e(),
        ],
        1
      ),
      _vm._t("default"),
      _c("Footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }